/* eslint-disable jsx-a11y/anchor-is-valid */
import { Button, Input } from "reactstrap";
import {
  BlockBetween,
  BlockContent,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../../../../components/Component";
import CardInner from "../../../../../components/cards/CardInner";
import LoadingComponent from "../../../../components/loader/tableLoader";

const LeadSettingsView = ({ settingsState, setIsEditLeadSettings }) => {
  const { globalSettings, loading, error } = settingsState;
  return (
    <CardInner size="lg">
      <BlockHead size="lg">
        <BlockBetween>
          <BlockHeadContent>
            <BlockTitle tag="h4">Lead Settings</BlockTitle>
            <BlockDes>
              <p>Settings for Leads.</p>
            </BlockDes>
          </BlockHeadContent>
          <BlockHeadContent>
            <Button
              className="d-none d-lg-inline"
              color="primary"
              style={{ marginTop: "-2rem" }}
              onClick={() => setIsEditLeadSettings(true)}
            >
              Edit
            </Button>
          </BlockHeadContent>
          <BlockHeadContent className="align-self-start d-lg-none">
            <a
              href="#"
              className="toggle btn btn-icon btn-trigger mt-n1"
              data-target="userAside"
            >
              <Icon name="menu-alt-r" />
            </a>
          </BlockHeadContent>
        </BlockBetween>
      </BlockHead>
      {error ? (
        <BlockHeadContent>
          <h6 className="text-danger">Failed to get settings</h6>
        </BlockHeadContent>
      ) : loading ? (
        <LoadingComponent />
      ) : (
        <>
          <BlockHead size={"sm"}>
            <BlockHeadContent>
              <h6>Leads New Flag Settings</h6>
            </BlockHeadContent>
          </BlockHead>
          <BlockContent>
          <div className="gy-3">
              <div className="g-item">
                <div
                  className="d-flex align-items-center justify-content-between"
                  style={{ gap: "1rem" }}
                >
                  <div className="form-group">
                    <label
                      className="form-label mt-3"
                      htmlFor="unassignLeadAfter"
                    >
                      Consider Lead "New" For
                    </label>
                    <span class="form-note">Specifies how long should a lead be considered "new" in Explorer</span>
                  </div>
                  <Input
                    type="text"
                    name="unassignLeadAfter"
                    disabled
                    defaultValue={globalSettings?.global?.explorerNewLeadDuration ?? " 7 days"} 
                    className="w-50"
                  />
                </div>
              </div>
            </div>
          </BlockContent>
          {/* Button renders on smaller screens */}
          <Button
            className="mt-4 d-lg-none"
            color="primary"
            onClick={() => setIsEditLeadSettings(true)}
          >
            Edit
          </Button>
        </>
      )}
    </CardInner>
  );
};

export default LeadSettingsView;
